import React, {Component} from "react";
import {observer, inject} from "mobx-react";
import {Modal, Timeline, Button} from "antd";
import axios from "axios";
import {NEWEST_VERSION} from "../../utils/constant";
import SvgIcon from "../../icon";

import "./VersionDialog.css";

@inject("dialog")
@observer
class VersionDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      versionNumber: 0,
      versionTimeline: [],
      recommend: null,
      specialInfo: "",
    };
  }

  handleOk = () => {
    this.props.dialog.setVersionOpen(false);
  };

  handleCancel = () => {
    this.props.dialog.setVersionOpen(false);
  };

  handleMore = () => {
    const w = window.open("about:blank");
    // w.location.href = "https://github.com/mdnice/markdown-nice/blob/master/CHANGELOG.md";
    w.location.href = "https://blog.fiveyoboy.com";
  };

  handleDocs = () => {
    const w = window.open("about:blank");
    // w.location.href = "https://preview.mdnice.com/articles/";
    w.location.href = "https://blog.fiveyoboy.com";
  };

  componentDidMount = async () => {
    try {
      // const {
      //   data: response,
      //   data: {data},
      // } = await axios.get("https://api.mdnice.com/versions/newest");
      // if (!response.success) {
      //   throw new Error();
      // }
      // const newestVersion = localStorage.getItem(NEWEST_VERSION);
      // if (data.versionNumber !== newestVersion) {
      //   this.props.dialog.setVersionOpen(true);
      //   localStorage.setItem(NEWEST_VERSION, data.versionNumber);
      // }
      const data = {
        "versionId": 119,
        "versionNumber": "0.1.17",
        "versionTimeline": [
            `更多工具请查看 `,
            "微信编辑器，拥有良好的兼容性、海量主题样式！",
            "提供文章一键排版，同时支持知乎、掘金、微信订阅号等多个平台。",
            "支持手机、平板电脑等移动设备访问使用！",
        ],
        "recommend": {
            "link": "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzI1MDU5MjYyMg==&action=getalbum&album_id=4000786195516194820",
            "mainInfo": "欢迎关注「五岁小孩」公众号"
        },
        "specialInfo": "<div style=\"display:flex;justify-content:center;align-items:center;\"><img style=\"width:50%;\" src=\"https://tools.fiveyoboy.com/assets/img/common/wxpoa.jpg\"/></div>",
        // "feature": {
        //     "productArticleUrl": "https://www.mdnice.com/writing/f8af366b739846b68dc70ad33238720e",
        //     "extensionArticleUrl": "https://www.mdnice.com/writing/88c7cf8bc94248cebae4888ee93216b2",
        //     "desktopArticleUrl": "https://www.mdnice.com/writing/76bc9003291b4797a4bfc6407a343bf3",
        //     "productArticleName": "产品指南",
        //     "extension": "https://files.mdnice.com/extension/mdnice_2_1_1.crx",
        //     "windows": "https://files.mdnice.com/desktop/Markdown-Nice-0.4.3.exe",
        //     "mac": "https://files.mdnice.com/desktop/Markdown-Nice-0.4.3.dmg"
        // },
        "createTime": "2025-05-18T10:14:15.000+0800",
        "updateTime": "2025-05-18T10:14:15.000+0800"
    }
      this.setState({...data});
      // 每次都打开版本对话框
      this.props.dialog.setVersionOpen(true);
    } catch (err) {
      console.error("读取最新Mdnice版本信息错误");
    }
  };

  render() {
    return (
      <Modal
        title="欢迎使用「五岁 MD 排版编辑器」"
        visible={this.props.dialog.isVersionOpen}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={[
          <Button key="submit" type="primary" onClick={this.handleOk}>
            确认
          </Button>,
        ]}
        destroyOnClose
      >
        <Timeline>
          {this.state.versionTimeline.map((version, index) => {
            if (index === 0) {
              return (
                <Timeline.Item key={index} dot={<SvgIcon name="environment" style={style.svgIcon} />}>
                  <strong>{version}</strong>
                  <a id="more-info-tools" title="五岁小站" href="https://tools.fiveyoboy.com/" target="_blank">五岁小站</a>
                </Timeline.Item>
              );
            } else {
              return <Timeline.Item key={index}>{version}</Timeline.Item>;
            }
          })}
          {/* <Timeline.Item>
           欢迎关注
            <a
              id="nice-version-dialog-doc"
              style={{fontWeight: "bold"}}
              alt=""
              href="https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzI1MDU5MjYyMg==&action=getalbum&album_id=4000786195516194820"
              rel="noopener noreferrer"
              target="_blank"
            >
              五岁小孩
            </a>
            公众号
          </Timeline.Item> */}
          {this.state.recommend && (
            <Timeline.Item dot={<SvgIcon name="more" style={style.svgIcon} />}>
              <a
                id="nice-version-dialog-recommend"
                style={{fontWeight: "bold", borderBottom: "double"}}
                alt=""
                href={this.state.recommend.link}
                rel="noopener noreferrer"
                target="_blank"
              >
                {this.state.recommend.mainInfo}
              </a>
            </Timeline.Item>
          )}
        </Timeline>
        {this.state.specialInfo && (
          <div
            id="nice-version-dialog-special"
            dangerouslySetInnerHTML={{__html: this.state.specialInfo}}
            className="specialInfo"
          />
        )}
      </Modal>
    );
  }
}

const style = {
  svgIcon: {
    width: "16px",
    height: "16px",
  },
};

export default VersionDialog;
